<template>
  <div class="contents_wrap">
    <div class="small_title_wrap">
      <h2>발송 정보 [받는 분]</h2>
    </div>
    <ul class="filter_list">
      <li>
        <dd>
          <label>수신<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input type="text"
                     :class="{'error' : errorTarget === 'receiveNm'}"
                     v-model.trim="sendInfo.receiveNm"
                     @input="sendInfo.receiveNm=EtnersCommonUtil.cutByteLength(sendInfo.receiveNm, 100)"
                     placeholder="수신 정보를 입력하세요.">
            </li>
          </ul>
        </dd>
        <dd>
          <label>발송 수단<span class="forg">*</span></label>
          <ul class="w50">
            <li class="w100">
              <div v-for="item in deliveryScnList">
                <input
                    class="k-radio"
                    type="radio"
                    name="deliveryScn"
                    :id="item.cdId"
                    :value="item.cdId"
                    @change="sendInfo.deliveryScn = item.cdId"
                    :checked="item.cdId === sendInfo.deliveryScn">
                <label :for="item.cdId" class="k-radio-label" style="width:100px">{{ item.cdNm }}</label>
              </div>
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>수신 연락처<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input type="text"
                     :class="{'error' : errorTarget === 'receiveTel'}"
                     v-model.trim="sendInfo.receiveTel"
                     @input="sendInfo.receiveTel=EtnersCommonUtil.cutByteLength(sendInfo.receiveTel, 20)"
                     placeholder="수신 연락처를 입력하세요.">
            </li>
          </ul>
        </dd>
        <dd>
          <label>내용물<span class="forg">*</span></label>
          <ul class="w80">
            <li>
              <div v-for="item in sendContentsScnList">
                <input
                    class="k-radio"
                    type="radio"
                    name="contentsScnRegi1"
                    :id="`${item.cdId}_contentsScnRegi1`"
                    :value="item.cdId"
                    @change="sendInfo.contentsScn = item.cdId"
                    :checked="item.cdId === sendInfo.contentsScn">
                <label :for="`${item.cdId}_contentsScnRegi1`" class="k-radio-label" style="width:80px">{{ item.cdNm }}</label>
              </div>
            </li>
          </ul>
        </dd>
      </li>
      <li v-if="sendInfo.contentsScn === '03'">
        <dd>
          <label></label>
          <ul class="w80"></ul>
        </dd>
        <dd>
          <label></label>
          <ul>
            <li>
              <input
                  class="w100"
                  :class="{'error' : errorTarget === 'contentsScnDesc'}"
                  v-show="sendInfo.contentsScn === '03'"
                  v-model="sendInfo.contentsScnDesc"
                  maxlength="100"
                  placeholder="내용물을 입력하세요."
              >
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>수신 주소<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input type="text"
                     class="w80"
                     style="display: inline-flex; border-width: 1px;"
                     :class="{'error' : errorTarget === 'receiveAddr'}"
                     v-model.trim="sendInfo.receiveAddr"
                     :readonly="true"
                     @click="onSearchPostCd"
                     placeholder="주소지 검색">
              <kendo-button
                  style="width:18%;"
                  class="mid_btn ml5"
                  @click="onSearchPostCd"
              > 검색
              </kendo-button>
            </li>
          </ul>
        </dd>
        <dd>
          <label>신고 금액<span v-if="sendInfo.ppsScn === '01'" class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input
                  class="w100"
                  :class="{'error' : errorTarget === 'regCost'}"
                  type="number"
                  min="0"
                  v-model="sendInfo.regCost"
                  @input="sendInfo.regCost = sendInfo.regCost.slice(0, 10)"
                  :placeholder="'신고 금액을 입력하세요.'"
              >
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>상세 주소<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <input type="text"
                     :class="{'error' : errorTarget === 'receiveAddrDtl'}"
                     v-model.trim="sendInfo.receiveAddrDtl"
                     @input="sendInfo.receiveAddrDtl=EtnersCommonUtil.cutByteLength(sendInfo.receiveAddrDtl, 500)"
                     placeholder="상세 주소를 입력하세요.">
            </li>
          </ul>
        </dd>
        <dd>
          <label>보관 위치<span class="forg">*</span></label>
          <ul class="w50">
            <li>
              <kendo-dropdownlist
                  class="w100"
                  :class="{'error' : errorTarget === 'lockerId'}"
                  ref="lockerIdRef"
                  v-model="sendInfo.lockerId"
                  :data-text-field="'lockerNm'"
                  :data-value-field="'lockerId'"
                  :option-label="'거점 선택 후 선택해주세요.'"
              >
              </kendo-dropdownlist>
            </li>
          </ul>
        </dd>
      </li>
      <li>
        <dd>
          <label>비고</label>
          <ul class="w50">
            <li>
              <input type="text"
                     :class="{'error' : errorTarget === 'contents'}"
                     v-model.trim="sendInfo.contents"
                     @input="sendInfo.contents=EtnersCommonUtil.cutByteLength(sendInfo.contents, 4000)"
                     placeholder="비고를 입력하세요.">
            </li>
          </ul>
        </dd>
        <dd>
          <label>무인 보관함 번호</label>
          <ul class="w50">
            <li>
              <input type="text"
                     v-model.trim="sendInfo.lockerCellId"
                     :disabled="true"
                     placeholder="무인 보관함 번호">
            </li>
          </ul>
        </dd>
      </li>
    </ul>
    <daum-postcode-window
        ref="daumPostCodeRef"
        v-on:send-addr-data="getAddrData"
    ></daum-postcode-window>
  </div>
</template>

<script>

import DaumPostcodeWindow from "@/components/DaumPostcodeWindow";
import {LogisticsCodeDtlMixin} from "@/mixin/Mixin";
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";
import EtnersCommonUtil from '@/common/etners.common.util'
import receiveInfo from '@/components/pouch/ReceiveInfo.vue'
import EtnersLogisticsUtil from '@/common/etners.logistics.util'

export default {
  name: "SendSaveRegi",
  mixins: [LogisticsCodeDtlMixin],
  components: {DaumPostcodeWindow},
  props: {
    propsSendInfo : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
    lockerNmDataSource : {
      type: Array,
      required: false,
      default : function (){
        return []
      }
    }
  },
  watch: {
    'propsSendInfo': {
      handler: function (val, oldVal) {
        return this.sendInfo = this.propsSendInfo
      },
      deep: true,
    },
    'lockerNmDataSource': {
      handler: function (val, oldVal) {
        this.$refs.lockerIdRef.kendoWidget().setDataSource(val)
        this.$refs.lockerIdRef.kendoWidget().value(this.sendInfo.lockerId)
        return val
      }
    }
  },
  computed: {
    receiveAddrWithPostNo () {
      const vm = this

      const receivePost = vm.sendInfo.receivePost
      const receiveAddr = vm.sendInfo.receiveAddr

      if(receivePost !== null && receiveAddr !== null){
        return `(${receivePost}) ${receiveAddr}`
      }else{
        return ''
      }
    }
  },
  methods: {
    getPropsSendInfo () {
      // 부모 컴포넌트(SendSave.vue)에서 호출
      const vm = this
      const sendInfo = vm.sendInfo

      // 유효성 검사
      if (EtnersCommonUtil.isEmpty(sendInfo.receiveNm)) {
        kendo.alert('수신을 입력해주세요.')
        vm.errorTarget = 'receiveNm'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.receiveTel)) {
        kendo.alert('수신 연락처를 입력해주세요.')
        vm.errorTarget = 'receiveTel'
        return
      } else if(!EtnersLogisticsUtil.isTelNum(sendInfo.receiveTel)){
        kendo.alert('수신 연락처를 형식에 맞게 입력해주세요.')
        vm.errorTarget = 'receiveTel'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.receiveAddr)) {
        kendo.alert('수신 주소를 입력해주세요.')
        vm.errorTarget = 'receiveAddr'
        return
      }
      if (EtnersCommonUtil.isEmpty(sendInfo.receiveAddrDtl)) {
        kendo.alert('상세 주소를 입력해주세요.')
        vm.errorTarget = 'receiveAddrDtl'
        return
      }
      if (vm.sendInfo.contentsScn==='04' && EtnersCommonUtil.isEmpty(vm.sendInfo.contentsScnDesc)) {
        kendo.alert('내용물을 입력해주세요.')
        vm.errorTarget = 'contentsScnDesc'
        return
      }
      if (vm.sendInfo.ppsScn === '01' && EtnersCommonUtil.isEmpty(sendInfo.regCost)) {
        kendo.alert('신고 금액을 입력해주세요.')
        vm.errorTarget = 'regCost'
        return
      } else if(vm.sendInfo.ppsScn === '01' && !EtnersCommonUtil.isPositiveInteger(sendInfo.regCost)){
        kendo.alert('신고 금액은 1이상의 숫자를 입력해주세요')
        vm.errorTarget = 'regCost'
        return
      }
      if (EtnersCommonUtil.isNotEmpty(sendInfo.regCost) && !EtnersCommonUtil.isPositiveInteger(sendInfo.regCost)) {
        kendo.alert('신고 금액은 1이상의 숫자를 입력해주세요')
        vm.errorTarget = 'regCost'
        return
      }
      if (!!vm.$refs.lockerIdRef) {
        const lockerId = vm.$refs.lockerIdRef.kendoWidget().value()
        if (EtnersCommonUtil.isEmpty(lockerId)) {
          kendo.alert('보관 위치를 선택해주세요.')
          vm.errorTarget = 'lockerId'
          return
        }
        vm.sendInfo.lockerId = lockerId
      }

      // setting
      vm.sendInfo.receiveTel = vm.sendInfo.receiveTel.replaceAll('-', '')

      if(!!vm.$refs.lockerIdRef) {
        const lockerId = vm.$refs.lockerIdRef.kendoWidget().value()
        if(!!lockerId) {
          vm.sendInfo.lockerId = lockerId
        }
      }

      vm.errorTarget = null
      return vm.sendInfo
    },

    onSearchPostCd () {
      const vm = this
      const refs = vm.$refs

      refs.daumPostCodeRef.$refs.daumPostCodeRef.kendoWidget().center().open()
    },

    getAddrData (addrData) {
      const vm = this

      vm.sendInfo.receiveAddr = addrData.addr
      vm.sendInfo.receivePost = addrData.zipCode
    },
  },
  data () {
    const vm = this
    return {
      EtnersCommonUtil: EtnersCommonUtil,
      loginUserToken : sessionStorage.getItem('loginUserToken'),
      sendInfo: {
        ...vm.propsSendInfo
      },
      addrData : {}, // 주소 검색 컴포넌트 용
      errorTarget: null, // 유효성 체크 error 클래스 활용
    }
  }
}
</script>

<style scoped>

</style>
